/**
 * OnboardingLayout Component
 * Feature: 013-shell-navigation
 *
 * Simplified layout for onboarding flow.
 * Shows only header - NO sidebar or bottom navigation.
 * Used during initial user setup before onboarding_complete = true.
 */

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
  selector: 'app-onboarding-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    HeaderComponent
  ],
  templateUrl: './onboarding-layout.component.html',
  styleUrl: './onboarding-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingLayoutComponent {}
